import { createAction } from '../../utils/redux/createAction';

const actionScope = 'test-call';

export const TEST_CALL_ACTION_TYPES = {
  INIT: `${actionScope}/init`,
  OPEN: `${actionScope}/open`,
  CLOSE: `${actionScope}/close`,
};

export const testCallActions = {
  init: createAction(TEST_CALL_ACTION_TYPES.INIT),
  open: createAction(TEST_CALL_ACTION_TYPES.OPEN),
  close: createAction(TEST_CALL_ACTION_TYPES.CLOSE),
};

const initialState = {
  opened: false,
  props: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TEST_CALL_ACTION_TYPES.OPEN: {
      return { ...state, opened: true, props: payload };
    }
    case TEST_CALL_ACTION_TYPES.CLOSE: {
      return { ...state, opened: false, props: {} };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/test-call.js